import dashboard3APIsService from "../dashboard3APIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard3Data = createDataHook(
  dashboard3APIsService,
  (filters, params, controller, apiService = dashboard3APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    /*fetchCourseOverviewTrendData: () =>
      apiService.fetchCourseOverviewTrendData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),*/
    fetchCourseBreakdownData: () =>
      apiService.fetchCourseBreakdownData(
        { ...params, limit: 10, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal,
      ),
    fetchCourseCompletionByMonthData: () =>
      apiService.fetchCourseCompletionByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    /*fetchOrganisationsWithCoursesData: () =>
      apiService.fetchOrganisationsWithCoursesData(
        { ...params },
        controller.signal
      ),*/
    fetchCourseCompletionData: () =>
      apiService.fetchCourseCompletionData({
        ...params,
        sortBy: "course",
        sortOrder: "asc",
      }, controller.signal),
    fetchOrganisationsWithWithoutCoursesData: () =>
      apiService.fetchOrganisationsWithWithoutCoursesData({
        ...params,
        sortBy: "organisation",
        sortOrder: "asc",
      }, controller.signal)/*
    fetchUsersByCourseCompletionData: () =>
      apiService.fetchUsersByCourseCompletionData({
        ...params,
        sortBy: "courseName",
        sortOrder: "asc",
      }, controller.signal),*/
  }),
  { preflight: "shared" }
);

export default useFetchDashboard3Data;
